export const buildFioFilter = (searchString: string | null): string => {
    if (!searchString) return ''
    if (!searchString?.trim()) return ''

    const tokens = searchString
        .toLowerCase()
        .trim()
        .split(/\s+/)
        .filter((t) => t.length > 0)

    if (tokens.length === 0) return ''

    const escapeToken = (token: string) => token.replace(/'/g, "''")

    if (tokens.length === 1) {
        const token = escapeToken(tokens[0])
        return `(contains(tolower(f),'${token}') or contains(tolower(i),'${token}') or contains(tolower(o),'${token}'))`
    }

    if (tokens.length === 2) {
        const [fToken, iToken] = tokens.map(escapeToken)
        return `(contains(tolower(f),'${fToken}') and contains(tolower(i),'${iToken}'))`
    }

    const [fToken, iToken, oToken] = tokens.slice(0, 3).map(escapeToken)
    return `(contains(tolower(f),'${fToken}') and contains(tolower(i),'${iToken}') and contains(tolower(o),'${oToken}'))`
}
